import React from "react";
import Routes from "./Routes";
import ChatbotButton from "./components/ChatbotButton";

function App() {
  return (
    <>
      <Routes />
      <ChatbotButton />
    </>
  );
}

export default App;
